var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiechtenstein(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0456 40 20 40C8.95437 40 0 31.0457 0 20C0.869531 20 20 17.3914 20 17.3914L40 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000366211 20C0.000366211 8.95438 8.95474 0 20.0004 0C31.046 0 40.0004 8.95438 40.0004 20",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7826 13.9131C14.7826 12.4724 13.6146 11.3044 12.1739 11.3044C11.5056 11.3044 10.8964 11.556 10.4348 11.9692V10.4348H11.3043V8.69564H10.4348V7.82611H8.69565V8.69564H7.82612V10.4348H8.69565V11.9692C8.23401 11.556 7.62487 11.3044 6.95651 11.3044C5.51581 11.3044 4.34784 12.4724 4.34784 13.9131C4.34784 14.6855 4.68385 15.3792 5.21737 15.857V17.3913H13.913V15.857C14.4467 15.3792 14.7826 14.6855 14.7826 13.9131V13.9131Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiechtenstein);
export default __webpack_public_path__ + "static/media/liechtenstein.eb495e3fcef2d8a823f03b58e61786a5.svg";
export { ForwardRef as ReactComponent };